export const SET_WINDOW_WIDTH = 'viewport/SET_WINDOW_WIDTH';
export const SET_IS_MOBILE = 'viewport/SET_IS_MOBILE';
export const SET_IS_MOBILE_APP = 'viewport/SET_IS_MOBILE_APP';
export const SET_IS_TABLET = 'viewport/SET_IS_TABLET';
